if (!customElements.get('dark-mode-toggle')) {
  class DarkModeToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.iconSun = this.querySelector('.icon-sun');
      this.iconMoon = this.querySelector('.icon-moon');
      this.button.addEventListener('click', this.toggle.bind(this));
      this.syncIcons();
    }

    get isDark() {
      return document.documentElement.dataset.theme === 'dark';
    }

    toggle() {
      const next = this.isDark ? 'light' : 'dark';
      document.documentElement.dataset.theme = next;
      localStorage.setItem('theme-mode', next);
      this.syncAllToggles();
      document.dispatchEvent(new CustomEvent('theme:changed', { detail: { theme: next } }));
    }

    syncIcons() {
      if (!this.iconSun || !this.iconMoon) return;
      if (this.isDark) {
        this.iconSun.style.display = '';
        this.iconMoon.style.display = 'none';
        this.button.setAttribute('aria-label', this.dataset.labelLight || 'Light mode');
      } else {
        this.iconSun.style.display = 'none';
        this.iconMoon.style.display = '';
        this.button.setAttribute('aria-label', this.dataset.labelDark || 'Dark mode');
      }
    }

    syncAllToggles() {
      document.querySelectorAll('dark-mode-toggle').forEach(el => el.syncIcons());
    }
  }

  customElements.define('dark-mode-toggle', DarkModeToggle);
}
